import { IconButton } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import AddCardIcon from '@mui/icons-material/AddCard';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import Tooltip from '@mui/material/Tooltip';
import {Dispatch, SetStateAction, useEffect, useState} from 'react';
import { Customer } from '../../model/Customer';
import { isMobile } from 'react-device-detect';
import {Dropdown, MenuProps, Popover} from 'antd';
import { HistoryPopover } from './HistoryPopover';
import { PaymentPopover } from './PaymentPopover';
import { PaymentSummaryRequestDTO } from '../../model/PaymentSummaryRequestDTO';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import dayjs from "dayjs";

export const CustomerForPaymentsElement : React.FC<{customer : Customer, 
    show : boolean, setShow : Dispatch<SetStateAction<boolean>>, index : number,
    handleSaveToDatabase : (paymentSummaryRequestDTO: PaymentSummaryRequestDTO, passedCustomerid : number) => Promise<() => void>,
    page : number
    customerIdsList : number[],
    setCustomerIdsList : Dispatch<SetStateAction<number[]>>
}> = (props) => {

    const {customer, index, handleSaveToDatabase, page,
        customerIdsList, setCustomerIdsList} = props
    const [showHistory, setShowHistory] = useState(false);
    const [showPayment, setShowPayment] = useState(false);
    const [currentBalance, setCurrentBalance] = useState<number | undefined>()
    const [balance, setBalance] = useState<number | undefined>()
    const items: MenuProps['items'] = [
        {
            label: (
                <IconButton onClick={() => setShowHistory(true)}>
                    <HistoryIcon />
                </IconButton>
            ),
            key: '0',
        },
        {
            label: (
                <Popover
                    placement="bottomRight"
                    overlayStyle={{
                        minWidth: `${isMobile ? "80vw" : "12vw"}`
                    }}
                    destroyTooltipOnHide
                    content={
                        <>
                            <PaymentPopover
                                paymentsummary={customer.paymentSummary}
                                passedCustomerid ={customer.customerid}
                                setShowPayment={setShowPayment}
                                handleSaveToDatabase={handleSaveToDatabase}/>
                        </>
                    }
                    trigger="click"
                    open={showPayment}
                    onOpenChange={(e) => setShowPayment(e)}
                >
                    <IconButton>
                        <AddCardIcon />
                    </IconButton>
                </Popover>
            ),
            key: '1',
        },
        {
            label: (
                <IconButton disabled={customer.email === "Brak"} onClick={customerIdsList.includes(customer.customerid!) ?
                    () => setCustomerIdsList(customerIdsList.filter(id => id !== customer.customerid!))
                    :
                    () => setCustomerIdsList(prevState => [...prevState, customer.customerid!])
                }>
                    {customerIdsList.includes(customer.customerid!) ? <MarkEmailReadIcon /> : <MailOutlineIcon />}
                </IconButton>
            ),
            key: '2',
        },
    ];

    useEffect(()=> {
        let totalsUndefined = customer.paymentSummary?.totalCosts === undefined ||
                              customer.paymentSummary?.totalPayments === undefined
        setCurrentBalance(totalsUndefined ? undefined : customer.paymentSummary?.totalCosts!
                                                       + customer.paymentSummary?.totalPayments!)

        let billingUndefined = customer.billings.find(billing => dayjs(billing.datePeriod)
            .startOf('month').isSame(dayjs().startOf('month')))?.billingTotalAmount === undefined
        setBalance(totalsUndefined || billingUndefined ? undefined :
            customer.paymentSummary?.totalCosts! + customer.paymentSummary?.totalPayments! +
            customer.billings
                .find(billing => dayjs(billing.datePeriod)
                    .startOf('month').isSame(dayjs().startOf('month')))!
                .billingTotalAmount!)
            
    },[customer.billings, customer.paymentSummary])

    return (
        <tr className={isMobile ? 'mobile-text-size align-middle' : 'align-middle'} key={index}>
            {isMobile ? <></> : <td>{index + 1 + (page - 1) * 10}</td>}
            <td>{customer.position}</td>
            <td>{customer.firstName}</td>
            <td>
                {`${customer.lastName} `}
                {customer.active ?
                    ""
                    :
                    <Tooltip
                        title="Ten rodzic został wcześniej usunięty. Na tej stronie będzie widoczny tylko do końca bieżącego miesiąca"
                        arrow placement="right">
                        <ErrorOutlineIcon fontSize="small" sx={{color: 'orange'}}/>
                    </Tooltip>
                }
            </td>
            {isMobile ?
                <></>
                :
                <>
                    <td>{customer.childName}</td>
                </>
            }
            <td>{currentBalance !== undefined ? `${currentBalance} zł` : 'Brak'}</td>
            <td>{balance !== undefined ? `${balance} zł` : 'Brak'}</td>
            <td>{customer.paymentSummary !== undefined ? `${customer.paymentSummary.totalPayments} zł` : 'Brak'}</td>
            {isMobile ?
                <td>
                    <Dropdown menu={{items}} trigger={['click']}>
                        <MoreVertIcon/>
                    </Dropdown>
                </td>
                :
                <td>
                    <IconButton onClick={() => setShowHistory(true)}>
                        <HistoryIcon/>
                    </IconButton>

                    <Popover
                        placement="bottomRight"
                        overlayStyle={{
                            minWidth: `${isMobile ? "80vw" : "12vw"}`
                        }}
                        destroyTooltipOnHide
                        content={
                            <>
                                <PaymentPopover
                                    paymentsummary={customer.paymentSummary}
                                    passedCustomerid={customer.customerid}
                                    setShowPayment={setShowPayment}
                                    handleSaveToDatabase={handleSaveToDatabase}/>
                            </>
                        }
                        trigger="click"
                        open={showPayment}
                        onOpenChange={(e) => setShowPayment(e)}
                    >
                        <IconButton>
                            <AddCardIcon/>
                        </IconButton>
                    </Popover>
                    <IconButton disabled={customer.email === "Brak"}
                                onClick={customerIdsList.includes(customer.customerid!) ?
                                    () => setCustomerIdsList(customerIdsList.filter(id => id !== customer.customerid!))
                                    :
                                    () => setCustomerIdsList(prevState => [...prevState, customer.customerid!])
                                }>
                        {customerIdsList.includes(customer.customerid!) ? <MarkEmailReadIcon/> : <MailOutlineIcon/>}
                    </IconButton>
                </td>
            }
            <HistoryPopover customer={customer} showHistory={showHistory} setShowHistory={setShowHistory}/>
        </tr>
    )
}